'use strict';

module.exports = require('ck-core/source/functions/makeLang')({
	NO_PROGRESS: 'Start coding now to see your progress report!',
	TITLE: 'Account Page',
	PROGRESS_TITLE: 'Progress',
	BILLING_PAGE_PROGRESS:
		"This is your personal progress, not the child account's progress. Please login into the child's account via the 'Your Accounts' option to see this information."
});
